module.exports = __webpack_public_path__ + "static/media/crossbeam-logo.782f2a87.svg";